<template>
  <el-container v-loading="isLoading" class="Edit">
    <el-header class="Edit-header">
      <el-page-header @back="close" content="修改内部账号"></el-page-header>
    </el-header>
    <el-main class="Edit-main">
      <el-form :model="form" ref="form" label-width="100px">
        <el-form-item label="角色" prop="roleId">
          <el-select v-model="form.roleId" placeholder="请选择角色">
            <el-option v-for="(item, index) in role" :label="item.roleName" :value="item.roleId" :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('form')">提交</el-button>
        </el-form-item>
      </el-form>
    </el-main>
  </el-container>
</template>

<script>
export default {
  name: 'Edit',
  data () {
    return {
      id: '',
      role: [],
      thisModule: {},
      isLoading: false,
      form: {
        roleId: ''
      }
    }
  },
  created () {
    let thisModule = this.myOption.requestModule.user.children.medOwner.children
    this.isLoading = true
    this.id = this.$store.state.user.editId
    this.thisModule = thisModule.modify
    this.thisModule.detail = thisModule.detail
    this.getDetail()
  },
  methods: {
    close () {
      this.myOption.switchListAndEdit(this, true)
    },
    // 获取角色列表
    getRoleList () {
      this.$axios({
        method: 'post',
        headers: {
          'Authorization': this.$store.state.user.token,
          'ModuleId': this.thisModule.id
        },
        url: this.myOption.requestUrl + this.thisModule.role,
        data: this.qs.stringify({
          startPage: 1,
          pageSize: this.myOption.pageSize.max
        })
      }).then((res) => {
        let code = res.data.code
        if (code === 200) {
          let data = res.data.data.data
          data.unshift({roleId: '', roleName: '不设置'})
          this.role = data
        } else {
          this.myOption.abnormalCode(this, code)
        }
      }).catch((err) => {
        this.myOption.abnormalCode(this, err)
      })
    },
    // 获取详情信息
    getDetail () {
      this.$axios({
        method: 'post',
        headers: {
          'Authorization': this.$store.state.user.token,
          'ModuleId': this.thisModule.detail.id
        },
        url: this.myOption.requestUrl + this.thisModule.detail.api,
        data: this.qs.stringify({
          userId: this.id,
          isSspUser: 1
        })
      }).then((res) => {
        let code = res.data.code
        if (code === 200) {
          let data = res.data.data
          if (data.roleInfoVo) {
            this.role = [{roleName: data.roleInfoVo.roleName, roleId: data.roleInfoVo.roleId}]
            this.form.roleId = data.roleInfoVo.roleId
          }
          this.getRoleList()
        } else {
          this.myOption.abnormalCode(this, code)
        }
        this.isLoading = false
      }).catch((err) => {
        this.myOption.abnormalCode(this, err)
        this.isLoading = false
      })
    },
    // 提交表单
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.isLoading = true
          this.$axios({
            method: 'post',
            headers: {
              'Authorization': this.$store.state.user.token,
              'ModuleId': this.thisModule.id
            },
            url: this.myOption.requestUrl + this.thisModule.api,
            data: this.qs.stringify({
              userId: this.id,
              roleId: this.form.roleId,
              isSspUser: 1
            })
          }).then((res) => {
            let code = res.data.code
            this.isLoading = false
            if (code === 200) {
              this.$message.success('修改内部账号成功')
              this.$router.push({path: this.$route.path.replace('/edit', '/list')})
            } else {
              this.myOption.abnormalCode(this, code)
            }
          }).catch((err) => {
            this.isLoading = false
            this.myOption.abnormalCode(this, err)
          })
        } else {
          return false
        }
      })
    },
    // 重置表单
    resetForm (formName) {
      this.$refs[formName].resetFields()
    }
  },
  beforeDestroy () {
    this.$store.dispatch('SetEditId', false)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/media_owner/Edit.vue